// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"ShopifyProducts_headerContainer__Qj4Mt"};